// Next
import { GetServerSideProps, NextPage } from 'next';
// Translate
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
// Types
import { LangEnum, RaceView } from '@utmb/types/index';
import { PageDefaultProps } from 'src/types';
import { StyleEnum } from '@utmb/types/enum/StyleEnum';
// Layout
import { Layout } from '@utmb/layouts/layout-base';
// Features Components
import { SlicesHandler } from '@utmb/features/slices-handler/SlicesHandler';
import { StatsBar } from '@utmb/features/race/stats-bar/StatsBar';
// import { MediaGallerySection } from '@utmb/features/race/media-gallery/MediaGallery';
import { RacePageHeader } from '@utmb/features/race/race-page-header/RacePageHeader';
// import { RegistrationBanner } from '@utmb/features/race/registration-banner/RegistrationBanner';
// Context, utils
import { i18n } from 'next-i18next.config';
import { PageProviders } from '@utmb/contexts/index';
import isMobile from '@utmb/utils/is-mobile';
import { fetchAPI } from '@utmb/utils/utmb';
// Styles
import { RaceTrackProvider } from '@utmb/contexts/RaceTrackContext';
import { ColorTypesEnum } from '@utmb/types/colors';

// MASONRY CAN'T BE SSR'ED AS NEEDS WINDOW
// const MediaGallery = dynamic<MediaGallerySection>(() => import('@utmb/features/race/media-gallery/MediaGallery').then((comp) => comp.MediaGallery as any), {
//     ssr: false,
// });

interface PageProps extends PageDefaultProps, RaceView {
    // magazineContent: MagazineProps;
}

const RacePage: NextPage<PageProps> = ({
    bannerStats,
    breadcrumbs,
    contentLocale,
    event,
    eventsTopBar,
    footer,
    host,
    isMobile,
    // magazineContent,
    mainStats,
    mobileBottomBar,
    navigation,
    simpleMenu,
    pageHeader,
    raceLink,
    raceId,
    raceLogo,
    raceTheme,
    raceThemeIsDark,
    url3d,
    gpxUrl,
    seo,
    slices,
    track,
    languages,
    partners,
}) => {
    // const sectionRefs = [
    //     { section: '#presentation', ref: presentationRef },
    //     { section: '#course', ref: courseRef },
    //     { section: '#experience', ref: experienceRef },
    //     { section: '#participate', ref: participateRef },
    // ];

    return (
        <PageProviders>
            <Layout
                {...seo}
                contentLocale={contentLocale}
                host={host}
                isMobile={isMobile}
                eventsTopBar={eventsTopBar}
                mobileBottomBar={mobileBottomBar}
                navigation={navigation}
                simpleMenu={simpleMenu}
                footer={footer}
                landing={true}
                event={event}
                raceTheme={raceTheme}
                partners={partners}
                languages={languages}
                menuLogoIsDark={true}
                breadcrumbs={breadcrumbs}
            >
                {/* Header Start */}
                {pageHeader && <RacePageHeader {...pageHeader} raceLogo={raceLogo} raceLink={raceLink} raceId={raceId} mainStats={mainStats} />}
                {/* Header End

                {/* ---------------------------------- */}
                {/* going to be switched by Slice RACE_STATS */}
                {bannerStats && !!bannerStats.length && (
                    <StatsBar
                        style={StyleEnum.NORMAL}
                        color={raceThemeIsDark ? ColorTypesEnum.WHITE : ColorTypesEnum.WS_PRIMARY}
                        stats={bannerStats.map((stat) => ({ ...stat, isDark: raceThemeIsDark }))}
                    />
                )}
                {/* ---------------------------------- */}

                {/* Voir avec Seb quelle composant vient ici et pour la position sticky */}
                {/*
                    <AnchorNavigation .../>
                    {raceRegister && (
                        <Link.Button
                            label={raceRegister.label}
                            href={raceRegister.slug}
                            color={ColorTypesEnum.WHITE}
                            bgcolor={ColorTypesEnum.DEFAULT}
                            variant="right"
                            className={styles.register}
                        />
                    )}
                */}

                {/* {eliteRunners && (
                    <section id="elite-runners" className={styles.section}>
                        <EliteRunners {...eliteRunners} of={eliteRunners.runners} isMobile={isMobile} />
                    </section>
                )} */}

                <RaceTrackProvider track={track} color={raceTheme} isDark={raceThemeIsDark} name={pageHeader.title} url3d={url3d} gpxUrl={gpxUrl}>
                    <SlicesHandler slices={slices} />
                </RaceTrackProvider>

                {/* Gallery Section Start - @todo */}
                {/* {gallery && <MediaGallery theme={raceTheme} {...gallery} />} */}
                {/* Gallery Section End */}
            </Layout>
        </PageProviders>
    );
};

export default RacePage;

export const getServerSideProps: GetServerSideProps<RaceView> = async ({ locale, defaultLocale, params, req }) => {
    try {
        // Translate
        const lang: LangEnum = (locale || defaultLocale || i18n.defaultLocale) as LangEnum;
        const translations = await serverSideTranslations(lang, ['common']);

        const host = req.headers.host;

        // Page Content
        const race = params!.race as string;
        const page = await fetchAPI(req, '/content/races', race, { lang });
        // if error
        if (!page) return { notFound: true };
        const {
            bannerStats,
            breadcrumbs,
            locale: contentLocale,
            mainStats,
            noIndex,
            pageHeader,
            playgrounds,
            raceId,
            raceLink,
            raceLogo,
            raceTheme,
            raceThemeIsDark,
            seo,
            slices,
            track,
            url3d,
            gpxUrl,
        } = page;

        return {
            props: {
                bannerStats,
                breadcrumbs,
                contentLocale,
                host,
                isMobile: isMobile(req),
                locale: lang,
                mainStats,
                noIndex,
                pageHeader,
                playgrounds,
                raceId,
                raceLink,
                raceLogo,
                raceTheme,
                raceThemeIsDark,
                seo,
                slices,
                track,
                url3d,
                gpxUrl,
                ...translations,
            },
        };
    } catch (error) {
        return {
            notFound: true,
        };
    }
};
